import omitDeep from "omit-deep-lodash";

import { apolloClient } from "../../../plugins/vue-apollo.js";

const formatResponse = response => ({ data: response.data });

const formatError = error => {
  // graphQLErrors, networkError, message, extraInfo
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    console.log("doMutation:graphQLErrors:", error.graphQLErrors[0]);
    return { error: error.graphQLErrors[0] };
  } else if (error.networkError) {
    if (
      error.networkError.result &&
      error.networkError.result.errors &&
      error.networkError.result.errors.length > 0
    ) {
      console.log(
        "doMutation:networkError:",
        error.networkError.result.errors[0]
      );
      return { error: error.networkError.result.errors[0] };
    }

    console.log("doMutation:networkError:", error.networkError);
    return { error: error.networkError };
  } else if (error.message) {
    console.log("doMutation:message:", error.message);
    return { error: error.message };
  } else if (error.extraInfo) {
    console.log("doMutation:extraInfo:", error.extraInfo);
    return { error: error.extraInfo };
  }

  return { error: error };
};

const cleanVariables = variables => {
  try {
    if (variables) return omitDeep(variables, "__typename");
  } catch (e) {
    console.log("graphqlHelper.cleanVariables:exception:", e.message);
  }

  return variables;
};

export const doQuery = ({ query, variables, fetchPolicy }) => {
  return apolloClient
    .query({
      query: query,
      variables: cleanVariables(variables),
      fetchPolicy: fetchPolicy,
    })
    .then(formatResponse)
    .catch(formatError);
};

export const doMutation = ({ mutation, variables }) => {
  return apolloClient
    .mutate({
      mutation: mutation,
      variables: cleanVariables(variables),
    })
    .then(formatResponse)
    .catch(formatError);
};
